
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
name: "auth",
components: {
XHeader, XInput,Group
},
data() {
return {
phone:'',
vercode:'',
stunum:'',
isright: function (value) {
return {
valid: value == 1,
msg: '请输入正确的身份证号'
}
},
}
},
mounted(){
this.stunum = this.$store.state.stu_num;
this.phone='12132432434';
},
methods:{
valide(){
this.$router.push({name: 'resetpass', params: {stunum: this.stunum}})
},
}
}



// WEBPACK FOOTER //
// ./src/components/Auth.vue